import { render, staticRenderFns } from "./HowPlace.vue?vue&type=template&id=374a1164&scoped=true&"
import script from "./HowPlace.vue?vue&type=script&lang=js&"
export * from "./HowPlace.vue?vue&type=script&lang=js&"
import style0 from "./HowPlace.vue?vue&type=style&index=0&id=374a1164&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374a1164",
  null
  
)

export default component.exports